import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=322d475d&scoped=true&"
import script from "./FootNav.vue?vue&type=script&lang=js&"
export * from "./FootNav.vue?vue&type=script&lang=js&"
import style0 from "./FootNav.vue?vue&type=style&index=0&id=322d475d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d475d",
  null
  
)

export default component.exports